import React, {Component} from 'react';
import { Api } from '../../utils/api';
import Grid from '@material-ui/core/Grid';
import { UserShow } from './user_show.component';

export class UserViewComponent extends Component {
  state = {
    user: null
  };

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {
    const {userId} = this.props;
    this.api.get(`/users/${userId}`)
      .then(({data = null}) => this.setState({user: data}));
  }

  componentDidUpdate(prevProps){
    const {userId} = this.props;
    if (prevProps.userId === userId) return;

    this.api.get(`/users/${userId}`)
      .then(({data = null}) => this.setState({user: data}));
  }

  render() {
    const {user} = this.state;
    const {userId} = this.props;
    return (
      <>
        <Grid container>
          {user && <UserShow {...user}/>}
          {!user && <div> Loading User {userId}... </div>}
        </Grid>
      </>
    );
  }
}

